// Initialise carousel components

( function( $, window, document, undefined ) {

	let $carousel = $('.js-carousel'),
			options = {
				autoplay: true,
				autoplaySpeed: 3000,
				pauseOnHover: true,
				dots: true,
				arrows: false,
				infinite: true,
				adaptiveHeight: false,
				draggable: true
			};

	if ( $carousel.length ) {
		$carousel.slick( options );
	}

} )( jQuery, window, document );
